<template>
  <!-- 订单详情页面 -->
  <div class="orderDetailPage">
    <!-- 头部状态 -->
    <section class="statusWrap" v-if="statusData.en">
      <OrderStatus :data="statusData" @refresh="init"></OrderStatus>
    </section>
    <!-- 订单信息 -->
    <section class="orderListWrap">
      <div class="showQR fhcud" v-if="isShowQR">
        <div id="orderDetailqrcode" v-if="isShowQR" class="fc"></div>
        <p>【到店】轮胎快修服务</p>
        <span>
          联系您的服务顾问扫描右方二维码，完成订单的最终确认才能生效（30分钟未确认，订单将自动取消）
        </span>
      </div>
      <DetailItemCard
        :data="{
          name: [3, 6, 9, 10, 101].includes(pageData.orderTypeFlag) ? '' : '商品信息'
        }"
        v-if="productsData && productsData.length"
      >
        <template #content>
          <div v-if="CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(pageData.orderTypeFlag)" class="productBox">
            <p class="verifyNo fvl" @click.stop="clickIcon(productsData[0]?.copyImg)">
              {{ `订单编号:${productsData[0]?.copyImg?.value}` }}
              <van-icon :name="productsData[0]?.copyImg?.src" size="14" color="#3088c5" />
            </p>
            <BaseCard :data="productsData[0]">
              <template #Ifn>
                <p class="baseSlot">
                  <span class="priceNum themeColor">¥{{ productsData[0]?.productPrice }}</span>
                  <span> x {{ productsData[0]?.productAmount }}</span>
                </p>
              </template>
            </BaseCard>
          </div>
          <div v-else class="productBox">
            <p class="verifyNo" v-if="pageData.orderTypeFlag === 3">
              {{ `订单编号:${pageData.orderNo}` }}
            </p>
            <PlanInfCard :data="productsData" :priceWeight="pageData.orderTypeFlag === 3" @clickBtn="clickBtn"></PlanInfCard>
          </div>
        </template>
      </DetailItemCard>
      <DetailItemCard v-for="(item, index) in detailData" :key="index" :data="item" @clickIcon="clickIconFn" />
      <p class="explain" v-if="pageData.orderTypeFlag === 3 && pageData.submitTypeFlag">
        <van-icon size="14" name="question-o" />
        <span>最终实际成交价格以所选梅赛德斯-奔驰授权经销商零售价格为准。</span>
      </p>
    </section>
    <!-- 操作确认弹窗 -->
    <van-dialog
      v-model:show="isShowDialog"
      title=""
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="dialogContent">
        <div v-if="dialogConfig.isTyreOrder" class="cancelReasonBox">
          <van-radio-group v-model="cancelReasonRes">
            <van-radio :name="index" icon-size="14px" v-for="(item, index) in cancelReason" :key="index">{{ item }}</van-radio>
          </van-radio-group>
        </div>
        <div v-else-if="dialogConfig.isContractOrder" class="contractOrderBox">
          <h4 class="contractTitle">{{ dialogConfig.title }}</h4>
          <p class="contractPay">
            付款金额：<span class="themeRed">￥{{ dialogConfig.payAmount }}</span>
          </p>
          <div class="contractOrderContent">
            <div class="contractOrderItem" v-for="item in dialogConfig.contractOrderList" :key="item.orderNo">
              <p>订单编号：{{ item.orderNo }}</p>
              <p class="productsNames">{{ item.productsNames }}</p>
            </div>
          </div>
        </div>
        <div v-else v-html="dialogConfig.content"></div>
      </div>
    </van-dialog>
    <!-- 底部按钮 -->
    <section class="bottomBtnWrap" v-if="btnData.length > 0">
      <BottomBtn :data="btnData" @click="clickBtn"></BottomBtn>
    </section>
    <SubmitOrder ref="showSubmitOrderPopUp" />
    <div v-show="false">
      <UseDealer ref="useDealerRef" :isShowPhone="true" :param="applyDealerParam"> </UseDealer>
    </div>
    <ContractServiceDeal :showPopUp="showPopUp" :datas="contractData" />
  </div>
</template>

<script>
import _ from 'lodash'
import { reactive, toRefs, onMounted, nextTick, ref, onUnmounted } from 'vue'
import { Toast } from 'vant'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import OrderStatus from '@/components/order/OrderStatus'
import DetailItemCard from '@/components/order/DetailItemCard'
import PlanInfCard from '@/components/order/PlanInfCard'
import BottomBtn from '@/components/order/BottomBtn'
import SubmitOrder from '@/components/order/SubmitOrder.vue'
import UseDealer from '@/components/canUseDealer/CurrentDealer'
import { btnCallBack, clickIcon, reorganizeDetailData, cancelReason, CONTRACT_SERVICES_ORDER_TYPE_FLAGS } from '@/util/order/handle'
import useDealerFn from '@/util/order/useDealer'
import { getOrderDetail, cancelOrder } from '@/api/order'
import { getContractOrderContent } from '@/util/order/tool'
import { showToast } from '@/util/couponCollection'
import QRCode from 'qrcodejs2'
import { backTop } from '@/util'
import { EWOrderTypeFlag } from '@/util/order/staticConfig'
import BaseCard from '@/components/directSales/BaseCard'
import ContractServiceDeal from '@/components/directSales/ContractServiceDeal'
import useContractServiceDealFn from '@/hooks/directSales/useContractServiceDeal'

export default {
  name: 'orderDetail',
  components: {
    OrderStatus,
    DetailItemCard,
    PlanInfCard,
    BottomBtn,
    SubmitOrder,
    UseDealer,
    BaseCard,
    ContractServiceDeal
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const query = router.currentRoute.value.query
    const showSubmitOrderPopUp = ref()
    const { applyDealerParam, viewUseDealer, useDealerRef } = useDealerFn()
    const { viewContractServiceDealFn, viewEWContractServiceDealFn, showPopUp, contractData } = useContractServiceDealFn()
    const state = reactive({
      orderId: query.orderId,
      orderTypeFlag: query.orderTypeFlag,
      miniMallOrder: query.miniMallOrder || 0, //minimall订单标识
      query,
      pageData: '',
      statusData: {},
      productsData: [],
      detailData: [],
      btnData: [],
      isShowDialog: false,
      isShowQR: false,
      disableImgUrl: '',
      dialogConfig: {},
      cancelReason,
      cancelReasonRes: '',
      // 轮胎订单刷新时间/毫秒
      refreshTime: 5000,
      applyDealerParam,
      CONTRACT_SERVICES_ORDER_TYPE_FLAGS
    })
    // 绘制二维码
    const makeQrcode = () => {
      let URL = `?from=orderDetail&orderNo=${state.pageData.orderNo}`
      state.qrcode = new QRCode('orderDetailqrcode', {
        width: 100,
        height: 100,
        text: URL, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      })
    }
    const toPay = param => {
      showSubmitOrderPopUp.value && showSubmitOrderPopUp.value.chosePayType && showSubmitOrderPopUp.value.chosePayType(param)
    }
    // 点击按钮
    const clickBtn = async v => {
      // console.log('clickBtn-->', v)
      const { orderTypeFlag, orderNo, submitTypeFlag, discountGroupId, payAmount } = v._data
      let param = { orderId: state.pageData.id, orderTypeFlag }

      // 使用v.btnId标识，组装参数数据
      if (v.param) {
        param = Object.assign(v.param, param)
      }
      // 执行异步回调函数
      if (v.fn) {
        // 取消订单、申请退款、撤销退款、售后、确认完成、激活需要弹窗确认
        if (['1', '3', '4', '5', '88', '89', '91', '92'].includes(v.btnId)) {
          if (v.btnId === '5') {
            param = { ...param, ...v }
          }
          if (v.btnId === '1') {
            param = { ...param, orderTypeFlag }
          }
          if (['91', '92'].includes(v.btnId)) {
            param = { ...param, serviceOrderId: v._item.serviceOrderInfo.id }
          }
          state.dialogConfig = Object.assign(v.dialogConfig, {
            subParam: { v, param }
          })
          state.isShowDialog = true
        } else {
          try {
            await btnCallBack(v, param)
            await init()
          } catch (e) {
            Toast({ message: e.message || '操作失败', position: 'bottom' })
          }
        }
      }
      // 取消轮胎预约订单
      const canceTyrelOrder = async param => {
        if (Number.isFinite(state.cancelReasonRes)) {
          param.profile = state.cancelReason[state.cancelReasonRes]
          param.orderTypeFlag = state.orderTypeFlag
          await cancelOrder(param)
        } else {
          throw Error('请选择一个取消原因')
        }
      }
      // 轮胎订单，取消需要弹窗
      if ('1' == v.btnId && orderTypeFlag === 3) {
        // submitTypeFlag":{1：到店订单 2：在线下单
        param.profile = ''
        state.dialogConfig = Object.assign(v.dialogConfig, {
          subParam: { v, param },
          cb: submitTypeFlag === 2 ? canceTyrelOrder : cancelOrder,
          isTyreOrder: submitTypeFlag === 2
        })
        state.cancelReasonRes = ''
        state.isShowDialog = true
      }
      // 服务合约订单，取消组合优惠需要弹窗
      if ('1' == v.btnId && [6, 9, 10].includes(orderTypeFlag)) {
        let contractOrderContent = await getContractOrderContent({
          discountGroupId,
          payAmount
        })
        // console.log('contractOrderContent--', contractOrderContent)
        if (contractOrderContent.isContractOrder && !contractOrderContent.contractOrderList.length) {
          return false
        }
        state.dialogConfig = Object.assign(
          v.dialogConfig,
          {
            subParam: { v, param },
            cb: cancelOrder
          },
          { ...contractOrderContent, title: '组合订单合并取消' }
        )
        state.isShowDialog = true
        return
      }
      // 服务合约订单，支付组合优惠需要弹窗
      if ('2' == v.btnId && [6, 9, 10].includes(orderTypeFlag)) {
        let contractOrderContent = await getContractOrderContent({
          discountGroupId,
          payAmount
        })
        param.orderNo = orderNo
        if (contractOrderContent.isContractOrder) {
          if (!contractOrderContent.contractOrderList.length) {
            return false
          }
          state.dialogConfig = Object.assign(
            {
              confirmButtonText: '确认支付',
              cancelButtonText: '取消'
            },
            {
              subParam: { v, param },
              cb: toPay,
              refresh: false
            },
            { ...contractOrderContent, title: '组合订单合并付款' }
          )
          state.isShowDialog = true
        } else {
          toPay(param)
        }
        return
      }
      // 服务合约订单，组合优惠-合并退款需要弹窗
      if ('3' == v.btnId && [6, 9, 10].includes(orderTypeFlag) && v.customDialog) {
        let contractOrderContent = await getContractOrderContent({
          discountGroupId,
          payAmount
        })
        param.orderNo = orderNo
        param.orderTypeFlag = state.orderTypeFlag
        if (contractOrderContent.isContractOrder) {
          if (!contractOrderContent.contractOrderList.length) {
            return false
          }
          v.fn = 'applyRefund'
          state.dialogConfig = Object.assign(
            {
              confirmButtonText: '一起退款',
              cancelButtonText: '取消'
            },
            {
              subParam: { v, param }
            },
            { ...contractOrderContent, title: '组合订单合并退款' }
          )
          state.isShowDialog = true
        }
        return
      }
      // 立即支付需要弹窗确认
      if ('2' == v.btnId) {
        showSubmitOrderPopUp.value.chosePayType({ orderNo, orderTypeFlag })
      }
      // 点击评价
      if (['6', '8', '9'].includes(v.btnId)) {
        console.log('跳转到评价页面')
      }
      if (v.btnId === '11') {
        //立即预约
        let { dealer: dealerInfo, carInfo } = v._data
        store.dispatch('setOabInfo', { dealerInfo, carInfo })
        let product = (state.pageData && state.pageData.products && state.pageData?.products[0]) || {}
        let { productId: loyaltyId = '', gsCode = '' } = product
        router.push({
          path: '/oabCreate',
          query: {
            from: 'orderDetail',
            orderId: state.orderId,
            loyaltyId,
            gsCode
          }
        })
      }
      if (v.btnId === '12') {
        //查看预约
        router.push({
          path: '/oabDetail',
          query: { from: 'orderDetail', oabId: v._data.oabInfo.reservationId }
        })
      }
    }

    //关闭弹窗
    const beforeCloseDialog = async action => {
      if (action === 'confirm') {
        try {
          const {
            subParam: { v, param },
            cb,
            refresh
          } = state.dialogConfig
          // console.log(state.dialogConfig.subParam,param)
          cb && (await cb(param))
          v.fn && (await btnCallBack(v, param))
          if (refresh === false) {
            return
          }
          await init()
          return true
        } catch (e) {
          Toast({ message: e.message || '操作失败', position: 'bottom' })
        }
      }
      if (action === 'cancel') {
        state.dialogConfig = {}
        state.cancelReasonRes = ''
        return true
      }
    }
    // 初始化页面数据
    const init = async () => {
      try {
        const id = state.orderId
        const miniMallOrder = state.miniMallOrder
        if (!id) return
        const data = await getOrderDetail({
          id,
          miniMallOrder,
          orderTypeFlag: state.orderTypeFlag
        })
        state.pageData = data
        let { statusData, productsData, detailData, btnData } = reorganizeDetailData({ ...data, _from: state?.query?.from })
        debugger
        // console.log(reorganizeDetailData(data));
        state.statusData = statusData
        state.productsData = productsData
        state.detailData = detailData
        state.btnData = btnData
        // 轮胎订单
        if (data.orderTypeFlag === 3) {
          if (statusData.en === 'awaitScan') {
            state.isShowQR = true
            nextTick(() => {
              makeQrcode()
            })
          }
          // 到店类型，待扫码/待支付状态轮询
          if (data.submitTypeFlag === 1 && ['awaitPay', 'awaitFinished', 'awaitScan'].includes(statusData.en)) {
            nextTick(() => {
              setTimeout(() => {
                // 轮询刷新
                refresh()
              }, state.refreshTime)
            })
          }
        }
      } catch (e) {
        Toast({ message: e.message || '数据请求失败', position: 'bottom' })
      }
    }
    // 轮询刷新
    let refresh = async () => {
      try {
        const id = state.orderId
        if (!id) return
        const data = await getOrderDetail({
          id,
          orderTypeFlag: state.orderTypeFlag
        })
        let { statusData, productsData, detailData, btnData } = reorganizeDetailData(data)
        state.statusData = statusData
        state.productsData = productsData
        state.detailData = detailData
        state.btnData = btnData
        // 轮胎订单
        if (data.orderTypeFlag === 3) {
          // console.log('statusData', statusData)
          if (statusData.en !== 'awaitScan') {
            state.isShowQR && (state.isShowQR = false)
          }
          // 到店类型，待扫码/待支付状态轮询
          if (data.submitTypeFlag === 1 && ['awaitPay', 'awaitFinished', 'awaitScan'].includes(statusData.en)) {
            nextTick(() => {
              setTimeout(() => {
                refresh && refresh()
              }, state.refreshTime)
            })
          }
        }
      } catch (e) {
        console.log('轮询刷新错误', e)
      }
    }
    onMounted(async () => {
      await init()
      backTop()
    })
    // 离开页面清除轮询
    onUnmounted(() => {
      refresh = null
    })
    const clickIconFn = data => {
      // console.log('clickIconFn---detail', data, data.key)
      if (data.key === 'viewUseDealer') {
        const orderId = state.pageData.id
        if (CONTRACT_SERVICES_ORDER_TYPE_FLAGS.includes(state.pageData.orderTypeFlag)) {
          let pram = { orderId, orderTypeFlag: state.pageData?.orderTypeFlag, sign: 'contractOrder', useclick: false }
          viewUseDealer && viewUseDealer(pram)
        } else {
          let product = (state.pageData && state.pageData.products && state.pageData?.products[0]) || {}
          let { productId: loyaltyId = '', gsCode = '' } = product
          loyaltyId && gsCode && viewUseDealer && viewUseDealer({ loyaltyId, gsCode, orderId, sign: 'loyaltyOrder' })
        }
        return
      }
      if (data.key === 'viewContract') {
        const notifications = state.productsData[0]?.notificationInfo
        const productType = state.productsData[0]?.productType
        // 如果 notificationInfo 为 null，showToast 提示
        if (!notifications) {
          showToast('告知书参数有误，请联系工作人员')
          return
        }
        if (state.orderTypeFlag == EWOrderTypeFlag) {
          let notification = {
            ..._.pick(notifications, ['fin', 'contactName', 'day', 'month', 'year', 'validPeriod', 'maxPurchaseMile', 'notificationFile', 'notificationName']),
            startDate: notifications.contractStartDate,
            endDate: notifications.validPeriod !== -1 && notifications.contractEndDate,
            sign: 'ewProduct',
            productType
          }

          if (productType === 'PRD_CATEGORY_7') {
            notification = {
              ...notification,
              maxPurchaseMile: notification.maxPurchaseMile == -1 ? '不限制' : notification.maxPurchaseMile,
              exceedMileStart: data.currentMile || '0',
              sign: 'ewUsedCarProduct',
              productType
            }
          }

          viewEWContractServiceDealFn(notification)
          return
        }
        if (state.pageData.orderTypeFlag === 6) {
          notifications.productName = state.productsData[0]?.productSkuName || ''
        }
        if (state.pageData.orderTypeFlag === 9) {
          notifications.sign = 'nevProduct'
        }
        if (state.pageData.orderTypeFlag === 10) {
          notifications.sign = 'wpProduct'
        }
        viewContractServiceDealFn(notifications)
        return
      }
      clickIcon(data)
    }

    return {
      ...toRefs(state),
      clickBtn,
      clickIcon,
      clickIconFn,
      init,
      beforeCloseDialog,
      showSubmitOrderPopUp,
      viewUseDealer,
      useDealerRef,
      showPopUp,
      contractData
    }
  }
}
</script>

<style lang="scss" scoped>
.orderDetailPage {
  width: 100vw;
  background-color: #f5f5f5;
  color: #666666;
  font-size: 14px;
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 38px 10px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
  }
  padding-bottom: calc(2px + constant(safe-area-inset-bottom));
  padding-bottom: calc(2px + env(safe-area-inset-bottom));
}
.baseSlot {
  margin-top: 4px;
  font-size: 14px;
  .priceNum {
    font-weight: 600;
  }
}

.statusWrap {
  padding: 10px;
  margin-top: 16px;
  background-color: #fff;
}
.orderListWrap {
  padding: 20px 20px 10px;
  background-color: #fff;
}
.productBox {
  margin-bottom: 10px;
}
.bottomBtnWrap {
  padding: 0px 0 40px;
  background-color: #fff;
}
.showQR {
  font-size: 12px;
  color: #333333;
  padding: 0 0 16px;
  p {
    font-size: 14px;
    font-weight: 600;
    padding: 12px 0;
  }
}
#orderDetailqrcode {
  width: 100px;
  height: 100px;
  padding: 5px;
  box-shadow: 0 0 2px #666666;
}
.explain {
  padding: 4px 20px 20px;
  color: #999;
  font-size: 12px;
  text-align: center;
  .van-icon {
    margin-right: 8px;
    vertical-align: middle;
  }
  span {
    vertical-align: middle;
  }
}
.verifyNo {
  padding: 0 0 10px;
  color: #666;
  text-align: left;
}
.cancelReasonBox {
  padding: 0 30px;
  .van-radio + .van-radio {
    margin-top: 10px;
  }
}
</style>
